/**
 * @generated SignedSource<<594c96facca8b9221801bb6332fe873a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobApplicationDialog_Job$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JobSpecConfirmationDialog_Job" | "useJobApplication_Job">;
  readonly " $fragmentType": "JobApplicationDialog_Job";
};
export type JobApplicationDialog_Job$key = {
  readonly " $data"?: JobApplicationDialog_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobApplicationDialog_Job">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobApplicationDialog_Job",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useJobApplication_Job"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobSpecConfirmationDialog_Job"
    }
  ],
  "type": "Job",
  "abstractKey": null
};

(node as any).hash = "c722657c65b3c069fee2f12e90bd79aa";

export default node;
